// extracted by css-extract-rspack-plugin
export default {"active":"zIOoTUAc8M12ntZe","shimmer":"ulXl6qA834042AW3","inactive":"C07Sh13Z3u4tlEaL"};